export namespace NumberHelper {
	export const precision3 = (num: number): number => {
		return Math.round(num * 1e3) / 1e3;
	};

	export const formatHumanize = (time: number, t: any) => {
		if (isNaN(+time) || !isFinite(+time) || 0.5 > Math.abs(time)) {
			return '';
		}

		var sign = time < 0 ? '-' : '';
		time = Math.abs(time);

		var hours = Math.floor(time / 3600),
			minutes = Math.floor(time / 60) % 60,
			seconds = Math.floor(time % 60);

		var formattedTime = sign;

		if (hours > 0) {
			formattedTime += hours + ' ' + (hours > 1 ? t('LABEL_HOURS') : t('LABEL_HOUR')) + ' ';
		}

		if (minutes > 0) {
			formattedTime += minutes + ' ' + (minutes > 1 ? t('LABEL_MINUTES') : t('LABEL_MINUTE')) + ' ';
		}

		if (seconds > 0) {
			formattedTime += seconds + ' ' + (seconds > 1 ? t('LABEL_SECONDS') : t('LABEL_SECOND')) + ' ';
		}

		return formattedTime;
	};

	export const getCurrentProgressPercentage = (current: number, length: number) => (Math.abs(current) / Math.abs(length)) * 100 - 100;

	export const percentageToPixels = (percentage: number, bottomControlBarRef: any | null) => {
		if (!bottomControlBarRef) {
			return 0;
		}
		return (bottomControlBarRef.getBoundingClientRect().width / 100) * percentage;
	};

	export const getRandomInt = (min: number, max: number) => {
		const minCeiled = Math.ceil(min);
		const maxFloored = Math.floor(max);

		const leadingZero = Array.from(new Array(max.toString().length))
			.map(() => '0')
			.join('')
			.trim();
		return (leadingZero + Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled)).slice(-max.toString().length); // The maximum is exclusive and the minimum is inclusive
	};
}
